import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { RegistrationApprovalModel } from '../../../features/workshop/models/registration-approval.model';
import { ProfileService } from '../../../features/profile/services/profile.service';

@Component({
  selector: 'app-registration-approval-prompt',
  templateUrl: './registration-approval-prompt.component.html',
  styleUrls: ['./registration-approval-prompt.component.css'],
  standalone: false,
})
export class RegistrationApprovalPromptComponent implements OnInit, OnDestroy {
  @Input() template?: TemplateRef<any>;

  registrationApprovalProps: RegistrationApprovalModel;
  subscription: Subscription;

  constructor(private profileService: ProfileService) {}

  ngOnInit() {
    this.fetchMyApprovalStatus();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private fetchMyApprovalStatus() {
    this.subscription = this.profileService
      .getMyRegistrationApprovalStatus()
      .subscribe((resp) => {
        this.registrationApprovalProps = resp;
      });
  }
}
